import { JSONSchemaType } from 'ajv'

export interface IModuleFormData {
  id: string
  name: string
  disabled: boolean
}

const ModuleSchema: JSONSchemaType<IModuleFormData> = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    id: {
      type: 'string',
    },
    disabled: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['name'],
  additionalProperties: false,
}

export default ModuleSchema
